import { Component } from '@angular/core';

@Component({
    selector: 'ddv-stacked-area-chart-icon',
    templateUrl: './stacked-area-chart-icon.component.html',
    styleUrls: ['./stacked-area-chart-icon.component.scss'],
})
export class StackedAreaChartIconComponent {}
